// ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        const el = document.getElementById("app-scroll");
        if (el) {
            el.scrollTo({ top: 0, left: 0, behavior: "auto" });
            return;
        }
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [pathname]);

    return null;
};

export default ScrollToTop;